/**
 * cart-drawer-open.js
 * ─────────────────────────────────────────────────────────────────
 * Intercepts clicks on any element linking to /cart and opens the
 * custom <cart-drawer> element instead of navigating to the cart page.
 *
 * Also auto-opens the drawer after a successful AJAX add-to-cart,
 * controlled by window.cartDrawerOpenOnAdd (set from Liquid via
 * the settings.cart_drawer_open_on_add theme setting).
 * ─────────────────────────────────────────────────────────────────
 */
(function () {
  'use strict';

  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  /**
   * Returns true when the given href points to the cart page.
   */
  function isCartHref(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname === CART_URL || url.pathname === '/cart';
    } catch (e) {
      return href === CART_URL || href === '/cart';
    }
  }

  /**
   * Refreshes the drawer's inner HTML from the section render API,
   * then opens it.
   */
  function openCartDrawer() {
        var drawerEl = document.getElementById('CartDrawer');
        if (!drawerEl) return;

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + '?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data && data['cart-drawer']) {
              var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
              var freshInner = doc.querySelector('.drawer__inner');
              var currentInner = drawerEl.querySelector('.drawer__inner');
              if (freshInner && currentInner) {
                currentInner.innerHTML = freshInner.innerHTML;
              }
              var freshCount = doc.querySelector('.cart-count-bubble');
              var currentCount = document.querySelector('.cart-count-bubble');
              if (freshCount && currentCount) currentCount.innerHTML = freshCount.innerHTML;
            }
          })
          .catch(function () { /* silent */ })
          .finally(function () {
            if (typeof drawerEl.open === 'function') {
              drawerEl.open();
            } else {
              drawerEl.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          });
      }

  // ── 1. Intercept any <a href="/cart"> click ──────────────────────
  document.addEventListener('click', function (e) {
    var anchor = e.target.closest('a[href]');
    if (!anchor) return;
    if (!isCartHref(anchor.getAttribute('href'))) return;
    if (!document.getElementById('CartDrawer')) return;

    e.preventDefault();
    e.stopPropagation();
    openCartDrawer();
  }, true); // capture phase — fires before any existing click handlers

  // ── 2. Intercept Dawn's cart-icon-bubble (#cart-icon-bubble) ────
  //    cart-drawer.js already sets this up, but only when the element
  //    resolves as a custom element. This is a plain-JS fallback.
  document.addEventListener('DOMContentLoaded', function () {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && document.getElementById('CartDrawer')) {
      bubble.setAttribute('role', 'button');
      bubble.setAttribute('aria-haspopup', 'dialog');
    }
  });

  // ── 3. Auto-open on AJAX add-to-cart ────────────────────────────
  //    Wraps window.fetch to detect successful /cart/add.js responses.
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input
            : input instanceof Request  ? input.url
            : String(input);

    return _origFetch.apply(this, arguments).then(function (response) {
      if (url.indexOf('/cart/add') !== -1 && response.ok) {
        var shouldOpen = window.cartDrawerOpenOnAdd !== false; // default true
        if (shouldOpen && document.getElementById('CartDrawer')) {
          setTimeout(openCartDrawer, 300);
        }
      }
      return response;
    });
  };

  // Expose globally for inline onclick usage
  window.openCartDrawer = openCartDrawer;
})();
